module.exports = __webpack_public_path__ + "img/Cuban_Bowl_Pork.032c78de.jpg";